import React from 'react';
import { Alert, Button, Space, Typography, Tag } from 'antd';
import { TeamOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useAgencyContext } from '../hooks/useAgencyContext';
import { FormattedMessage } from 'react-intl';

const { Text } = Typography;

export const AgencyBanner: React.FC = () => {
    const { isInAgencyContext, clientOrganisationName, returnToAgency, isLoading, agencyContext } = useAgencyContext();

    if (!isInAgencyContext) {
        return null;
    }

    const accessLevel = agencyContext?.agencyContext?.accessLevel;

    return (
        <Alert
            type="info"
            showIcon
            icon={<TeamOutlined />}
            style={{
                margin: '0',
                borderRadius: '0',
                borderLeft: 'none',
                borderRight: 'none',
                borderTop: 'none',
                background: 'linear-gradient(90deg, #e0f2fe 0%, #f0f9ff 100%)',
                borderColor: '#7dd3fc',
            }}
            message={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Space>
                        <Text strong>
                            <FormattedMessage
                                id="agency.banner.viewing"
                                defaultMessage="Viewing:"
                            />
                        </Text>
                        <Text strong style={{ color: '#0369a1' }}>
                            {clientOrganisationName}
                        </Text>
                        <Tag color={accessLevel === 'MANAGER' ? 'blue' : 'default'}>
                            {accessLevel === 'MANAGER' ? (
                                <FormattedMessage id="agency.banner.accessManager" defaultMessage="Manager" />
                            ) : (
                                <FormattedMessage id="agency.banner.accessViewer" defaultMessage="Viewer" />
                            )}
                        </Tag>
                    </Space>

                    <Button
                        type="link"
                        size="small"
                        icon={<ArrowLeftOutlined />}
                        loading={isLoading}
                        onClick={returnToAgency}
                        style={{
                            color: '#0369a1',
                            padding: '2px 8px',
                            height: 'auto',
                            fontSize: '12px',
                        }}
                    >
                        <FormattedMessage
                            id="agency.banner.returnToAgency"
                            defaultMessage="Return to Agency"
                        />
                    </Button>
                </div>
            }
        />
    );
};
